import React from 'react';
import {
  TableRow,
  TableCell,
} from '@material-ui/core';

import { Stroller } from '../../types';
import { PATH_DASHBOARD } from '../../app';
import { CommonMoreMenu } from '../../components';
import { useOnItemClick } from '../../hooks/useOnItemClick';

type CELL = {
  name: string,
  render?: (data: Stroller, cell: CELL) => string,
}

type StrollerProps = {
  data: Stroller,
}

const CELLS: CELL[] = [
  {
    name: 'id',
  },
  {
    name: 'firstName',
  },
  {
    name: 'lastName',
  },
  {
    name: 'country',
    render: (data, cell): string => data[cell.name]?.name || '-',
  },
  {
    name: 'model',
    render: (data, cell): string => data[cell.name]?.name || '-',
  },
  {
    name: 'color',
    render: (data, cell): string => data[cell.name]?.name || '-',
  },
];

const TableRowStyles = {
  cursor: 'pointer',
};

const UPDATING_LINK = PATH_DASHBOARD.strollers.root;

export const StrollersItem:React.FC<StrollerProps> = ({
  data,
}): JSX.Element => {
  const { onItemClick } = useOnItemClick(UPDATING_LINK, data.id);

  return (
    <TableRow
      hover
      sx={TableRowStyles}
    >
      {CELLS.map((cell) => (
        <TableCell
          key={cell.name}
          onClick={onItemClick}
        >
          {cell.render ? cell.render(data, cell) : data[cell.name]}
        </TableCell>
      ))}
      <TableCell align="right">
        <CommonMoreMenu
          itemId={data.id}
          updatingLink={UPDATING_LINK}
        />
      </TableCell>
    </TableRow>
  );
};
